import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "lastest-order-panel"
};
var _hoisted_2 = {
  key: 0,
  class: "loading-wrap"
};
var _hoisted_3 = {
  key: 1,
  class: "empty"
};
var _hoisted_4 = {
  class: "text"
};
import { getHistoryOrders } from "@/api/order";
import { OrderStatusEnum } from "@/constant/order";
import { useOrder } from "@/hooks/useOrder";
import { onActivated } from "vue";
import { ref } from "vue";
import OrderCard from "./OrderCard.vue";
import Button from "../base/Button.vue";
export default {
  __name: 'LastestOrderPanel',
  setup: function setup(__props) {
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var loading = ref(true);
    var curOrder = ref(null);
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _res$data$data;
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getHistoryOrders({
                page_num: 1,
                page_size: 1,
                order_status: [OrderStatusEnum.TO_PAY, OrderStatusEnum.TO_ACCEPT, OrderStatusEnum.PREPARING, OrderStatusEnum.READY, OrderStatusEnum.OUT_OF_DELIVERY]
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK && ((_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.length) > 0) {
                curOrder.value = res.data.data[0];
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    onActivated(function () {
      fetchData();
    });
    return function (_ctx, _cache) {
      var _component_van_loading = _resolveComponent("van-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_loading, {
        type: "spinner"
      })])) : !curOrder.value && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("youHaveNoOrdersRecently")), 1), _createVNode(Button, {
        class: "btn",
        onClick: _unref(toOrderView)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("orderNow")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])) : (_openBlock(), _createBlock(OrderCard, {
        key: 2,
        item: curOrder.value
      }, null, 8, ["item"]))]);
    };
  }
};